import { render, staticRenderFns } from "./SingleBannerSlider.vue?vue&type=template&id=0174b72e&"
import script from "./SingleBannerSlider.vue?vue&type=script&lang=js&"
export * from "./SingleBannerSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports